import api from '../../utils/api'

import FormSystemUser from './components/FormSystemUser'
import { useContext, useEffect, useState } from 'react'
/* contexts */
import { Context } from '../../context/UserContext'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function NewSystemUser({ handleOnSuccess, btCancelAction }) {
    const { register } = useContext(Context)
    const [myPermission, setMyPermission] = useState({ group: "", })
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const handleRegister = async (user) => {

        let msgText = 'Cadastro realizado com sucesso !'
        let msgType = 'success'
        try {
            const data = await api.post('/user/register', user).then((response) => {
                return response.data
            })

            /* navigate('/') */

        } catch (error) {

            msgText = error.response.data.message
            msgType = 'error'

        }

        setFlashMessage(msgText, msgType)
        if (msgType != "error") {
            handleOnSuccess()
        }


    }
    useEffect(() => {
        api.get('/user/get/permission', {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        })
            .then((response) => {
                setMyPermission(response.data.permission)
            })
    }, [])
    return (



        <div >
            {myPermission.group === "DEV_MASTER" || myPermission.group === "ADM_USER" ? (
                <FormSystemUser btnText={"Cadastrar"} permissionData={myPermission} title={'Novo Usuário do Sistema'} changePassword={'disable'} handleSubmit={handleRegister} btCancelAction={btCancelAction} />
            ) : (
                <div></div>
            )}
        </div>

    )
}

export default NewSystemUser